import { createTheme } from '@mui/material/styles';

export const styleOverrides = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          color: '#1a191b',
          fontWeight: 600,
          fontSize: '14px',
          textDecoration: 'underline',
          textTransform: 'none',
          '&:hover': {
            background: 'none',
          },
        },
        outlinedPrimary: {
          border: '2px solid #0a7ac4',
          borderRadius: 0,
          color: '#0a7ac4',
          fontSize: '14px',
          textDecoration: 'none',
          '&:hover': {
            border: '2px solid #4c494f',
            color: '#4c494f',
          },
        },
      },
    },
  },
});
